import { Grid16, List16 } from '@carbon/icons-react';
import { Tooltip } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FileAttachment } from 'api/attachments';
import { Switcher } from 'components/atoms/switcher';
import { CpSwitcher } from '../../components/cp-switcher';
import {
  Content,
  ContentTitle,
  ContentTitleWrapper,
  Holygrail,
} from './components';
import { CpFilesGridView } from './files-grid-view';
import { CpFilesListView } from './files-list-view';
import { CpFilesSidePane } from './files-side-pane';
import { CpAllFilesProps, ListOrGridMode } from './types';

export const CpAllFilesForLaptop: React.FC<CpAllFilesProps> = ({
  search,
  currentFolder,
  mode,
  setMode,
  currentAttachments,
  handleDownload,
  data,
  onFolderClick,
  onFileClick,
  projectId,
}) => {
  return (
    <Holygrail>
      <CpFilesSidePane
        search={search}
        projectId={projectId}
        currentFolder={currentFolder}
        onFolderClick={onFolderClick}
        data={data}
      />
      <Content fullWidth={!!search?.trim()}>
        {currentFolder ? (
          <>
            <ContentTitleWrapper>
              <ContentTitle>{currentFolder?.folderName}</ContentTitle>
              <CpSwitcher
                hoverBgColor="white"
                activeColor="black"
                data-mode={mode}
                value={mode}
              >
                <Tooltip title={<FormattedMessage id="cp.list_view" />}>
                  <Switcher.Button
                    value={ListOrGridMode.List}
                    checked={mode === ListOrGridMode.List}
                    onClick={() => setMode(ListOrGridMode.List)}
                  >
                    <List16 />
                  </Switcher.Button>
                </Tooltip>
                <Tooltip title={<FormattedMessage id="cp.grid_view" />}>
                  <Switcher.Button
                    value={ListOrGridMode.Grid}
                    checked={mode === ListOrGridMode.Grid}
                    onClick={() => setMode(ListOrGridMode.Grid)}
                  >
                    <Grid16 />
                  </Switcher.Button>
                </Tooltip>
              </CpSwitcher>
            </ContentTitleWrapper>
            {mode === ListOrGridMode.Grid ? (
              <CpFilesGridView
                onFileClick={(x) => onFileClick(x?.attachmentId)}
                attachments={currentAttachments as FileAttachment[]}
                onDownload={(a) => handleDownload(a?.attachmentId)}
              />
            ) : (
              <CpFilesListView
                onFileClick={(x) => onFileClick(x?.attachmentId)}
                attachments={currentAttachments}
                onDownload={(a) => handleDownload(a?.attachmentId)}
              />
            )}
          </>
        ) : (
          <></>
        )}
      </Content>
    </Holygrail>
  );
};
